import React from "react";
import WakoCelebrating from "../../../../assets/mascots/wako/Celebrating.svg";
import MascotScreen from "../components/MascotScreen";
import CelebrationEffects from "../components/CelebrationEffects";

export default function CompleteStep({ onFinish }) {
  return <MascotScreen image={WakoCelebrating} imageAlt="Wako celebra que completaste el registro" title="Su registro está listo." description="Su familia está lista para comenzar su experiencia en Arawaks." duration={5000} actionLabel="Ir a mi perfil ahora" onDone={onFinish} celebrating badge="Registro completado" showCountdown>
    <CelebrationEffects/>
  </MascotScreen>;
}
